export default __webpack_public_path__ + "static/media/image-011.684dfe99.jpg";